export const getSessionIdFromCar = (car) =>
  car?.sessionId ?? car?.session_id ?? null

export const getCarContextKey = (car, fallbackSessionId = null) => {
  if (!car?.plate) {
    return null
  }

  const sessionId = getSessionIdFromCar(car) ?? fallbackSessionId

  if (!sessionId) {
    return `plate:${car.plate}`
  }

  return `session:${sessionId}|plate:${car.plate}`
}
